// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1Y3N_","alertIcon":"ConfirmModal_alertIcon__uF2Dt"};